import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'

class PricingSchedule extends PureComponent {
    constructor(props) {
        super(props)

        this.state = {

        }
    }

    render() {
        const tableStyles = {
            tableWrap: {
                backgroundColor: '#fff',
                border: '1px solid var(--border-light)',
                borderRadius: '16px',
                boxShadow: '0 20px 45px -35px rgba(12, 23, 84, 0.35)',
                overflow: 'hidden'
            }
        };

        const noteStyles = {
            noteBox: {
                background: 'linear-gradient(135deg, #d8fbe6 0%, #baf5d5 100%)',
                border: '1px solid #7ed8a7',
                borderLeft: '8px solid #0f9d58',
                borderRadius: '14px',
                padding: '1.15rem 1.25rem',
                boxShadow: '0 18px 36px -28px rgba(15, 157, 88, 0.85)'
            },
            noteBadge: {
                display: 'inline-block',
                backgroundColor: '#0f9d58',
                color: '#fff',
                fontSize: '0.72rem',
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                borderRadius: '999px',
                padding: '0.2rem 0.6rem',
                marginBottom: '0.55rem',
                fontWeight: 700
            },
            noteText: {
                margin: 0,
                fontSize: '1.05rem',
                fontWeight: 600,
                color: '#084c2a',
                lineHeight: 1.35
            },
            noteLink: {
                color: '#05603a',
                textDecoration: 'underline'
            },
            noteEmailLink: {
                color: '#05603a',
                textDecoration: 'underline',
                fontWeight: 700
            }
        };

        return (
            <div className="container-md">
                {!this.props.isStandalone &&<h2>Addons</h2>}
                <div style={tableStyles.tableWrap}>
                    <div className="table-responsive">
                        <table className="table mb-0">
                            <thead className="bg-light">
                                <tr>
                                    <th>Subscription Item</th>
                                    <th>Standard Pricing</th>
                                    {this.props.isStandalone && <th className="text-success">Price if using RosswarePay</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {!this.props.isStandalone && <tr>
                                    <td><Link className="underlined" style={{ textDecoration: 'underline' }} to="/rosswarepay">Integrated Payments</Link></td>
                                    <td><Link className="underlined" style={{ textDecoration: 'underline' }} to="/rosswarepay">Learn more</Link></td>
                                </tr>}
                                {!this.props.isStandalone && <tr>
                                    <td>Dedicated hands-on training</td>
                                    <td><Link className="underlined" style={{ textDecoration: 'underline' }} to="/contact">Contact us</Link></td>
                                </tr>}
                                {this.props.isStandalone && <tr>
                                    <td>Legacy Support (updates and product support) <br /><small>SD-Support pricing scales based on how many active technicians your company has, from 1 tech to 11+.</small>
                                    </td>
                                    <td>$85 - $110/mo</td>
                                    <td className="text-success font-weight-bolder">$50 - $75/mo</td>
                                </tr>}
                                <tr>
                                    <td>SD-Mobile (technician app)</td>
                                    <td>$32/user/mo</td>
                                    {this.props.isStandalone && <td className="text-success font-weight-bolder">$19/user/mo</td>}
                                </tr>
                                <tr>
                                    <td>SD-CyberOffice (communication automation)</td>
                                    <td>Usage based, <a href="https://help.rossware.com/docs/other/sd-cyberoffice/detailed-pricing" className="underlined" style={{ textDecoration: 'underline' }}>click here</a></td>
                                    {this.props.isStandalone && <td className="text-success font-weight-bolder">Same as standard</td>}
                                </tr>
                                <tr>
                                    <td>DispatchLinks (ServiceBench, ServicePower, etc)</td>
                                    <td>$29/mo</td>
                                    {this.props.isStandalone && <td className="text-success font-weight-bolder">$20/mo</td>}
                                </tr>
                                <tr>
                                    <td>SD-RevenueBuilder (recurring service)</td>
                                    <td>$49/mo</td>
                                    {this.props.isStandalone && <td className="text-success font-weight-bolder">$39/mo</td>}
                                </tr>
                                <tr>
                                    <td>SD-Dealer (merchandise sales)</td>
                                    <td>$49/mo</td>
                                    {this.props.isStandalone && <td className="text-success font-weight-bolder">$33/mo</td>}
                                </tr>
                                <tr>
                                    <td>Server Hosting</td>
                                    <td><Link to="/hosting" className="underlined" style={{ textDecoration: 'underline' }}>Tiered pricing</Link></td>
                                    {this.props.isStandalone && <td className="text-success font-weight-bolder">Same as standard</td>}
                                </tr>
                                <tr>
                                    <td>American Home Shield Status Updater</td>
                                    <td>$10/mo</td>
                                    {this.props.isStandalone && <td className="text-success font-weight-bolder">Same as standard</td>}
                                </tr>
                                <tr>
                                    <td>SmartParts</td>
                                    <td>$35/mo</td>
                                    {this.props.isStandalone && <td className="text-success font-weight-bolder">Same as standard</td>}
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                {!this.props.isStandalone && (
                    <div style={noteStyles.noteBox} className="mt-4">
                        <div style={noteStyles.noteBadge}>Savings</div>
                        <p style={noteStyles.noteText}>
                            Users of <Link to="/rosswarepay" style={noteStyles.noteLink}>RosswarePay</Link> recieve a discount on some subscription items,
                            contact <a href="mailto:billing@rossware.net" style={noteStyles.noteEmailLink}>billing@rossware.net</a> to learn more.
                        </p>
                    </div>
                )}
            </div>
        )
    }
}

export default PricingSchedule
